import { render, staticRenderFns } from "./ActionTypeASelector.vue?vue&type=template&id=4731ca20&scoped=true"
import script from "./ActionTypeASelector.vue?vue&type=script&lang=js"
export * from "./ActionTypeASelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731ca20",
  null
  
)

export default component.exports